<template>
  <div class="w-100 bg-white" v-if="list.length">
    <div class="row calendar-header">
      <div
        v-for="fld in fields"
        :key="fld.key"
        class="col-lg"
        :class="fld.classObj">
        {{ fld.label }}
      </div>
    </div>
    <div
      class="row calendar-body"
      :class="{ bgOdd: index % 2 !== 0 }"
      v-for="(item, index) in list"
      :key="item._user.uid">
      <div class="col-lg team" :style="getSelectedStyle(item._user.color)">
        <div class="row">
          <div class="col-sm" style="margin: 10px" v-b-popover.hover.bottom="getRoleLabel(item._user)">
            {{ item._user.name }}
          </div>
        </div>
      </div>
      <div
        class="col-lg block"
        :class="{
          'full-block': isFullBlock(item[fields[i + 1].key]),
          project: item[fields[i + 1].key][0].type === 'project',
          'stripe-bg': hasHolidayCalss(
            item[fields[i + 1].key][0],
            'stripe-bg'
          ),
          'wfa-stripe-bg': hasHolidayCalss(
            item[fields[i + 1].key][0],
            'wfa-stripe-bg'
          ),
          weekend: ['weekend', 'bankholiday'].includes(
            item[fields[i + 1].key][0].type
          )
        }"
        v-for="(_, i) in new Array(14)"
        :key="fields[i + 1].key">
        <div
          v-for="block in item[fields[i + 1].key]"
          :key="block._blockId"
          :class="{
            'full-block': isFullBlock(item[fields[i + 1].key]),
            project: block.type === 'project',
            'stripe-bg':
              block.type === 'holiday' && block.assignment.title !== 'WFA',
            'wfa-stripe-bg':
              block.type === 'holiday' && block.assignment.title === 'WFA',
            weekend: ['weekend', 'bankholiday'].includes(block.type)
          }"
          :style="
            block.type === 'project'
              ? setProjectColorAsBg(block.assignment)
              : ''
          ">
          <h6
            v-if="block.type === 'holiday'"
            :style="setHolidayBlockStyle(block, item[fields[i + 1].key].length)">
            <b-badge variant="warning">{{
              block.assignment.title
            }}</b-badge>
          </h6>
          <h6
            v-if="['bankholiday', 'weekend'].includes(block.type)"
            :style="setHolidayBlockStyle(block, item[fields[i + 1].key].length)">
            <b-badge variant="info">{{
              getBankHolidayLabel(block)
            }}</b-badge>
          </h6>
          <span v-if="block.type === 'project'">{{
            block.assignment.title
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaffingCalendar',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    Getter() {
      return this.$store.getters
    },
    staffingDraggedProject() {
      return this.Getter.staffingDraggedProject
    },
    RoleLabels() {
      return this.Getter.staffingUserRoleLabels
    }
  },
  mounted() {},
  methods: {
    commitToStore(commitName, value) {
      this.$store.commit(commitName, value)
    },
    getBankHolidayLabel(block) {
      const isAssignment = block?.assignment ?? false
      const [_, date] = block._blockId.split('_')
      const fld = this.fields.find((fld) => fld._date === date)
      if (!fld.bankHolidayLabel) {
        return isAssignment && !fld.classObj.weekend ? isAssignment.title : ''
      }
      return isAssignment && !fld.classObj.weekend
        ? isAssignment.title
        : fld.bankHolidayLabel.replace('bank holiday', '').trim()
    },
    isFullBlock(block) {
      const oneAssignee = block.length === 1
      const isBankHoliday = block[0].type === 'bankholiday'
      return isBankHoliday || oneAssignee
    },
    hasHolidayCalss(block, className) {
      let allowed = block.type === 'holiday'
      switch (className) {
        case 'stripe-bg':
          allowed = allowed && block.type === 'holiday'
          break
        case 'wfa-stripe-bg':
          allowed = allowed && block?.assignment?.title === 'WFA'
          break
        default:
          allowed = false
      }
      return allowed
    },
    getSelectedStyle(color) {
      return {
        'background-color': color,
        color: '#fff'
      }
    },
    setProjectColorAsBg(project) {
      if (!project) {
        return {
          background: 'rgba(255, 255, 255, 0.5) !important',
          height: '48% !important'
        }
      }
      return {
        'background-color': project?.color ?? '#000',
        height: '98% !important'
      }
    },
    setHolidayBlockStyle(block, len = 1) {
      if (block.type === 'bankholiday') {
        return {
          'line-height': '56px !important'
        }
      }
      const isHalfDayHoliday =
        block.type === 'holiday' && ['HALF-DAY', 'HALF PERSONAL', 'WFH (OUTSIDE UK)'].includes(block?.assignment?.type)

      return {
        'line-height': isHalfDayHoliday && len === 2 ? '29px !important' : '56px !important'
      }
    },
    getRoleLabel({role}) {
      return this.RoleLabels?.[role] ?? 'N/A'
    }
  }
}
</script>

<style scoped>
.calendar-header .team,
.calendar-header .day-holder,
.calendar-body .team,
.calendar-body .block {
  flex: 0 0 6.66667% !important;
  max-width: 6.66667% !important;
}

.calendar-header {
  background: linear-gradient(135deg, #002d54 0%, #0054aa 100%) !important;
  border-radius: 8px 8px 0 0 !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  font-weight: 700;
  font-size: 9pt;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  height: 44px;
  line-height: 44px;
  margin: 0 !important;
  padding: 0 !important;
  max-width: 100% !important;
  overflow: hidden;
}
.calendar-header .team {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.15) !important;
  padding: 0 !important;
  text-align: center;
  font-weight: 800;
}
.calendar-header .loading {
  background-color: #ef4444 !important;
  color: #fff;
}
.calendar-header .day-holder {
  text-align: center;
  padding: 0 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.08) !important;
}
.calendar-header .day-holder.today {
  background-color: #0073be !important;
  font-weight: 800;
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.2);
  padding: 0 !important;
}
.calendar-header .day-holder.weekend {
  background-color: rgba(0, 0, 0, 0.15) !important;
  color: rgba(255, 255, 255, 0.85) !important;
  padding: 0 !important;
}
.calendar-header .day-holder.weekend.today {
  color: #fff !important;
}
.calendar-body {
  background-color: #ffffff;
  min-height: 60px;
  max-height: 60px;
  margin: 0 !important;
  padding: 0 !important;
  max-width: 100% !important;
  border-bottom: 1px solid #cbd5e1;
  transition: background-color 0.2s ease;
}
.calendar-body:hover {
  background-color: #f8fafc !important;
}
.calendar-body.bgOdd {
  background-color: #f1f5f9 !important;
  padding: 0 !important;
}
.calendar-body.bgOdd:hover {
  background-color: #f8fafc !important;
}
.calendar-body .team {
  color: #fff;
  font-size: 10pt;
  font-weight: 700;
  padding: 0 !important;
  display: flex;
  justify-content: left;
  align-items: center;
  height: 60px !important;
  max-height: 60px !important;
  border-right: 2px solid #cbd5e1 !important;
  border-top: 1.5px solid rgba(255, 255, 255, 0.3) !important;
  border-bottom: 1.5px solid rgba(0, 0, 0, 0.1) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  box-shadow: inset -3px 0 6px rgba(0, 0, 0, 0.05);
}
.calendar-body .block {
  display: block;
  text-align: center;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  padding: 0 !important;
  height: 60px !important;
  max-height: 60px !important;
  border-right: 1px solid #e2e8f0;
}
.calendar-body .block.weekend {
  background-color: #e2e8f0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
}
.calendar-body .block:hover {
  background-color: #f1f5f9;
  cursor: default;
  padding: 0 !important;
}
.calendar-body .block h6 {
  margin: 0 !important;
  padding: 0 !important;
}
.calendar-body .block .project {
  border-radius: 4px;
  margin: 1px 0;
  padding: 2px 6px;
  font-size: 14.5px;
  color: #fff;
  font-weight: 600;
  overflow-wrap: break-word;
  overflow-y: auto;
  max-width: 100% !important;
  width: 100% !important;
  min-height: 49% !important;
  max-height: 49% !important;
  height: 49% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.calendar-body .block .project.full-block {
  min-height: 98% !important;
  max-height: 98% !important;
  height: 98% !important;
}
.calendar-body .block .project:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}
.block-text-shadow {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15) !important;
}
.stripe-bg {
  background: repeating-linear-gradient(
      45deg,
      rgba(156, 39, 176, 0.18),
      rgba(156, 39, 176, 0.18) 8px,
      rgba(156, 39, 176, 0.32) 8px,
      rgba(156, 39, 176, 0.32) 16px
    ) !important;
  color: #7b1fa2 !important;
  border: 1px solid rgba(156, 39, 176, 0.35) !important;
}
.wfa-stripe-bg {
  background: repeating-linear-gradient(
      45deg,
      rgba(244, 63, 94, 0.18),
      rgba(244, 63, 94, 0.18) 8px,
      rgba(244, 63, 94, 0.32) 8px,
      rgba(244, 63, 94, 0.32) 16px
    ) !important;
  color: #be123c !important;
  border: 1px solid rgba(244, 63, 94, 0.35) !important;
}
</style>
